export enum OrderStatus {
	REGISTERED = "REGISTERED",
	ATENDED = "ATENDED",
	ANULATED = "ANULATED",
	UNREGISTERED = "UNREGISTERED",
}
